export default "__VITE_ASSET__BK$84eOE__"